// reducers/counterReducer.js
import { createSlice } from '@reduxjs/toolkit'
const deletedocument = createSlice({
  name:"deletedocument",
  initialState:false,
  reducers:{
    DeletedocumentData(state,action){
      return action.payload;
    },
    ResetdocumentData(){
      return null
    }
  }
}) 
export default deletedocument.reducer;
export const {DeletedocumentData,ResetdocumentData}=deletedocument.actions;